import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { isEmpty } from 'lodash';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import * as todoAction from './store/Testing.action';
import * as systemMasterAction from '../../../SystemMasters/Store/SystemMasters.action';
import { checkArray, Page_Size as PageSize, showBigImage, hideImage, shortenStringWithTooltip } from '../../../../Components/helper';
import noImage from '../../../../assets/images/no-image.png';
import '../Todo.css';
import { mappedArray, productFieldArray, testFieldArray } from './Constant';
import { multiStatusPart, singleStatusPart, setTitleForExp } from './StatusComp';
import ForPreview from '../../../DevlopmentOrder/Testing/ForPreview';
import Loader from '../../../../Components/Utility/Loader/Loader';

function List({ loading, selectedColumns, userId, userRole, subBrandAccess }) {
  const [state, setState] = useState({
    stateTestingTodoList: [],
    selectedIdsArray: [],
    isSelectAll: false,
  });
  const { t } = useTranslation('common');
  const [catBasedOnPTData, setCatBasedOnPTData] = useState(false);

  const [showForPreview, setShowForPreview] = useState(false);
  const [reportId, setReportId] = useState([]);
  const [prevData, setprevData] = useState([]);
  const [previewDevId, setDevOrderIdForPreview] = useState(null);

  const {
    TestingTodoListData: {
      testingListData,
      testingFilterValues: {
        sortOrder,
        sortPropertyName,
        searchText,
        selectedBrand,
        selectedProductSupplier,
        selectedSeason,
        selectedMonth,
        selectedYear,
        selectedCategory1,
        selectedCategory2,
        selectedCategory3,
        selectedCategory4,
        selectedTestingType,
        selectedBOM,
        selectedComponentSupplier,
        selectedColourRef,
        selectedStatus,
        selectedExpiry,
        selectedExclude,
        selectedStartDate,
        selectedEndDate,
      },
    },
  } = useSelector((reduxState) => reduxState);

  const dispatch = useDispatch();

  const [showColumn, setShowColumn] = useState([]);

  useEffect(() => {
    const fetchCatBasedOnPTData = async () => {
      try {
        const res = await dispatch(systemMasterAction.getCatBasedOnPT());
        setCatBasedOnPTData(!!res);
      } catch (e) {
        setCatBasedOnPTData(false);
      }
    };
    fetchCatBasedOnPTData();
  }, [dispatch]);

  const handleSelection = (id) => {
    let selectIds = [...state.selectedIdsArray];
    if (typeof id === 'boolean') {
      setState((prevState) => ({
        ...prevState,
        isSelectAll: id,
      }));
      if (!id) selectIds = [];
      else selectIds = state.stateTestingTodoList.map((ele) => ele._id);
    } else {
      const itemIndex = selectIds.findIndex((val) => val === id);
      if (itemIndex >= 0) selectIds.splice(itemIndex, 1);
      else selectIds.push(id);
      if (selectIds.length !== state.stateTestingTodoList.length) {
        setState((prevState) => ({
          ...prevState,
          isSelectAll: false,
        }));
      } else {
        setState((prevState) => ({
          ...prevState,
          isSelectAll: true,
        }));
      }
    }
    setState((prevState) => ({
      ...prevState,
      selectedIdsArray: selectIds,
    }));
    dispatch(todoAction.setTestingSelectedIds(selectIds));
  };

  useEffect(() => {
    if (selectedColumns) {
      setShowColumn([...selectedColumns.map((ele) => ele.label)]);
    }
  }, [selectedColumns]);

  useEffect(() => {
    if (Array.isArray(testingListData)) {
      if (!isEmpty(testingListData)) {
        const testingListData1 = testingListData.map((data) => {
          if (data?.expandData && !isEmpty(data?.expandData)) {
            data.isExpanded = false;
          }
          return data;
        });

        setState((prevState) => ({
          ...prevState,
          stateTestingTodoList: testingListData1,
        }));
      } else {
        setState((prevState) => ({
          ...prevState,
          stateTestingTodoList: testingListData,
        }));
      }
    }
  }, [testingListData]);

  const onSortColumn = async (propertyName) => {
    const selectedTestField = testFieldArray.find((item) => item.label === propertyName);
    const selectedProductField = productFieldArray.find((item) => item.label === propertyName);
    let sortProperty;
    if (selectedTestField) {
      sortProperty = `expandData.${selectedTestField.display}`;
    } else if (selectedProductField) {
      sortProperty = selectedProductField.display;
    } else {
      sortProperty = propertyName;
    }

    const sortObj = {
      brand: selectedBrand,
      productSupplier: selectedProductSupplier,
      seasons: selectedSeason,
      month: selectedMonth,
      year: selectedYear,
      category1: selectedCategory1,
      category2: selectedCategory2,
      category3: selectedCategory3,
      category4: selectedCategory4,
      testingType: selectedTestingType,
      BOM: selectedBOM,
      componentSupplier: selectedComponentSupplier,
      colourRef: selectedColourRef,
      status: selectedStatus,
      expiry: selectedExpiry,
      exclude: selectedExclude,
      type: 'testing',
      sortPropertyName: sortProperty,
      searchText,
      pageIndex: 1,
      pageSize: PageSize,
      startDate: selectedStartDate,
      endDate: selectedEndDate,
    };
    if (sortOrder === '' || sortOrder === 'Desc') {
      const obj = {
        sortOrder: 'Asc',
        sortPropertyName: sortProperty,
      };
      dispatch(todoAction.filterSortData(obj));
      dispatch(todoAction.getTestingList({ ...sortObj, sortOrder: 'Asc' }));
    } else {
      const obj = {
        sortOrder: 'Desc',
        sortPropertyName: sortProperty,
      };
      dispatch(todoAction.getTestingList({ ...sortObj, sortOrder: 'Desc' }));
      dispatch(todoAction.filterSortData(obj));
    }
  };

  const headerSortingIcon = (lable, propertyName, _orderType) => {
    return (
      <span className="cursor-pointer">
        {lable}
        {sortPropertyName === propertyName || sortPropertyName === `expandData.${propertyName}` ? (
          <>
            {sortOrder === '' && <i className="fa fa fa-sort ml-1" />}
            {sortOrder === 'Asc' && <i className="fa fa fa-sort-up ml-1" />}
            {sortOrder === 'Desc' && <i className="fa fa fa-sort-desc ml-1" />}
          </>
        ) : (
          <i className="fa fa fa-sort ml-1" />
        )}
      </span>
    );
  };

  const expandTesting = (index) => {
    const stateTesting = state.stateTestingTodoList;
    stateTesting[index].isExpanded = !stateTesting[index].isExpanded;
    setState((prevState) => ({
      ...prevState,
      stateTestingTodoList: stateTesting,
    }));
  };

  const openForPreview = (prevItem) => {
    setReportId(prevItem?.testReport?._id);
    setprevData(prevItem?.testReport);
    setDevOrderIdForPreview(prevItem?.devOrderId);
    setShowForPreview(true);
  };

  const togglePreview = async () => {
    setShowForPreview(false);
    setprevData(null);
    setReportId('');
  };

  const showCreatedandModified = (item) => {
    return (
      <button type="button" className="btn btn-action-icon " style={{ margin: '0', padding: '0 2px !important' }}>
        <div className="info-container testing-action-spaceremoval">
          <span className="icon-info  f-14" />
          <div className="info-content">
            {item?.createdBy && (
              <p className="text-left m-0">
                <strong>{t('ADD_PO_TEMPLATE_PROVIDER.CREATED')}</strong> : {`${item?.createdBy} | `}
                {moment(item?.createdAt).format('DD-MMMM-YYYY, h:mm a')}
              </p>
            )}
            {item?.modifiedBy && (
              <p className="text-left m-0">
                <strong>{t('ADD_PO_TEMPLATE_PROVIDER.MODIFIED')}</strong> : {`${item?.modifiedBy} | `}
                {moment(item?.updatedAt).format('DD-MMMM-YYYY, h:mm a')}
              </p>
            )}
          </div>
        </div>
      </button>
    );
  };

  const forChild = (data, i) => {
    return (
      data.isExpanded &&
      !isEmpty(data.expandData) &&
      data.expandData.length > 1 &&
      data.expandData.map((ele, ind) => {
        return (
          <tr key={ind}>
            <td />
            <td />
            <td>
              <div className="image-detail hover-right">
                <figure onMouseOver={(e) => showBigImage(e)} onMouseLeave={() => hideImage()}>
                  <div className="img-preview-inside-table sm">
                    <img width="60" alt="product img" src={data.image || noImage} />
                  </div>
                </figure>
              </div>
            </td>
            <td className="last-fix-col">
              {data?.number ? shortenStringWithTooltip(data?.number, 60) : '--'}
              <Link 
                className="cursor-pointer text-dark text-decoration-none" 
                to={`/development-order/${data?._id}/testing/testing-requirements`}
                target="_blank" 
                rel="noopener noreferrer"
              >
                <i className="icon-detail_page pl-1 text-dark" />
              </Link>
            </td>

            {productFieldArray.map((product) => {
              if (
                showColumn.includes(product.label) &&
                (product.label !== 'Sub Brand' || subBrandAccess) &&
                (product.label !== 'Product Type' || catBasedOnPTData)
              ) {
                if (product.display === 'suppliers') {
                  const suppliers = data[product.display] || [];
                  const visibleSuppliers = userRole === 'Supplier' ? suppliers.filter((s) => s._id === userId) : suppliers;
                  if (visibleSuppliers.length === 0) {
                    return <td key={product.value}>--</td>;
                  }
                  const supplierNames = visibleSuppliers
                    .map((s) => s?.name || '--')
                    .filter((name) => name && name !== 'undefined' && name !== 'null')
                    .join(', ');
                  return <td key={product.value}>{supplierNames || '--'}</td>;
                }
                return <td key={product.value}>{data[product.display] ? shortenStringWithTooltip(data[product.display], 60) : '--'}</td>;
              }
              return null;
            })}

            {testFieldArray.map((test) => {
              if (showColumn.includes(test.label)) {
                if (test.label === 'Test Reports') {
                  return (
                    <td key={test.value}>
                      {ele[test.display] ? (
                        <button type="button" className="btn" onClick={() => openForPreview(ele)} title="Preview">
                          <span className="icon-preview-template" />
                        </button>
                      ) : (
                        '--'
                      )}
                    </td>
                  );
                }
                if (test.display === 'status') {
                  return (
                    <td key={test.value}>
                      <div className="d-flex justify-content-center align-items-center">
                        {singleStatusPart(ele, t)} {ele?.createdBy && showCreatedandModified(ele)}
                      </div>
                    </td>
                  );
                }
                return <td key={test.value}>{shortenStringWithTooltip(ele[test.display], 60) || '--'}</td>;
              }
              return null;
            })}
          </tr>
        );
      })
    );
  };

  return (
    <>
      <table className="table custom-table layout-fixed font-13 text-center todo-fixed-col-table fixed-col-table-po">
        <thead>
          <tr>
            <th className="w-80px w-xs-40px">
              <div className="checkbox-label no-label margin-auto">
                <input
                  type="checkbox"
                  onChange={(e) => handleSelection(e.target.checked)}
                  name="check_all_samples"
                  id="check_all_samples"
                  checked={state.isSelectAll}
                  disabled={!state.stateTestingTodoList.length}
                />
                <label htmlFor="check_all_samples" className="chklabel">
                  <span />
                </label>
              </div>
            </th>
            <th className="w-80px w-xs-40px" />
            <th className="w-80px" />

            <th className="w-150px last-fix-col" onClick={() => onSortColumn('number')}>
              {headerSortingIcon(t('TABLE_HEADERS_LIST.PRODUCT_REF'), t('TABLE_HEADERS_LIST.NUMBER'), t('TABLE_HEADERS_LIST.ASC'))}
            </th>
            {!showColumn?.length && isEmpty(state?.stateTestingTodoList) && <th />}
            {mappedArray.map((col) => {
              if (showColumn.includes(col.label) && (col.label !== 'Sub Brand' || subBrandAccess) && (col.label !== 'Product Type' || catBasedOnPTData)) {
                return (
                  <th key={col.value} className="w-150px" onClick={() => onSortColumn(col.label)}>
                    {headerSortingIcon(col.label, col.display, 'Asc')}
                  </th>
                );
              }
              return null;
            })}
          </tr>
        </thead>
        <tbody>
          {checkArray(state.stateTestingTodoList) &&
            state?.stateTestingTodoList?.map((data, i) => {
              return (
                <>
                  <tr key={i}>
                    <td>
                      <div className="checkbox-label no-label margin-auto">
                        <input
                          onChange={() => {
                            handleSelection(data?._id);
                          }}
                          name={`checks_${i}`}
                          id={`checks_${i}`}
                          type="checkbox"
                          checked={state.selectedIdsArray.filter((val) => val === data?._id).length > 0}
                        />
                        <label htmlFor={`checks_${i}`} className="chklabel">
                          <span />
                        </label>
                      </div>
                    </td>
                    <td>
                      {data?.expandData &&
                        data?.expandData?.length > 1 &&
                        (data.isExpanded ? (
                          <button type="button" className="btn-up-down" onClick={() => expandTesting(i)}>
                            <span className="icon-new-down-arrow-icon icon-inverse" />
                          </button>
                        ) : (
                          <button type="button" className="btn-up-down" onClick={() => expandTesting(i)}>
                            <span className="icon-new-down-arrow-icon" />
                          </button>
                        ))}
                    </td>
                    <td>
                      <div className="image-detail hover-right">
                        <figure onMouseOver={(e) => showBigImage(e)} onMouseLeave={() => hideImage()}>
                          <div className="img-preview-inside-table sm">
                            <img width="60" alt="product img" src={data.image || noImage} />
                          </div>
                        </figure>
                      </div>
                    </td>
                    <td className="last-fix-col">
                      {data?.number ? shortenStringWithTooltip(data?.number, 60) : '--'}
                      <Link 
                        className="cursor-pointer text-dark text-decoration-none" 
                        to={`/development-order/${data?._id}/testing/testing-requirements`} 
                        target="_blank" 
                        rel="noopener noreferrer">
                        <i className="icon-detail_page pl-1 text-dark" />
                      </Link>
                    </td>
                    {productFieldArray.map((product) => {
                      if (
                        showColumn.includes(product.label) &&
                        (product.label !== 'Sub Brand' || subBrandAccess) &&
                        (product.label !== 'Product Type' || catBasedOnPTData)
                      ) {
                        if (product.display === 'suppliers') {
                          const suppliers = data[product.display] || [];
                          const visibleSuppliers = userRole === 'Supplier' ? suppliers.filter((s) => s._id === userId) : suppliers;
                          if (visibleSuppliers.length === 0) {
                            return <td key={product.value}>--</td>;
                          }
                          const supplierNames = visibleSuppliers
                            .map((s) => s?.name || '--')
                            .filter((name) => name && name !== 'undefined' && name !== 'null')
                            .join(', ');
                          return <td key={product.value}>{supplierNames || '--'}</td>;
                        }
                        const value = data[product.display];
                        const text = typeof value === 'object' ? value?.name || '--' : value || '--';

                        return <td key={product.value}>{shortenStringWithTooltip(text, 60)}</td>;
                      }
                      return null;
                    })}

                    {data?.expandData?.length > 1
                      ? testFieldArray.map((test) => {
                          if (showColumn.includes(test.label)) {
                            if (test.display === 'status') {
                              return <td key={test.value}>{multiStatusPart(data?.expandData, t)}</td>;
                            }
                            return <td key={test.value}>{setTitleForExp(data?.expandData, test.display, t)}</td>;
                          }
                          return null;
                        })
                      : testFieldArray.map((test) => {
                          if (showColumn.includes(test.label)) {
                            if (test.label === 'Test Reports') {
                              return (
                                <td key={test.value}>
                                  {data?.expandData[0][test.display] ? (
                                    <button
                                      type="button"
                                      className="btn"
                                      aria-label="Preview"
                                      onClick={() => openForPreview(data?.expandData[0])}
                                      title="Preview"
                                    >
                                      <span className="icon-preview-template" />
                                    </button>
                                  ) : (
                                    '--'
                                  )}
                                </td>
                              );
                            }
                            if (test.display === 'status') {
                              return (
                                <td key={test.value}>
                                  <div className="d-flex justify-content-center align-items-center">
                                    {singleStatusPart(data?.expandData[0], t)}
                                    {data?.expandData[0]?.createdBy && showCreatedandModified(data?.expandData[0])}
                                  </div>
                                </td>
                              );
                            }
                            return <td key={test.value}>{shortenStringWithTooltip(data?.expandData[0][test.display], 60) || '--'}</td>;
                          }
                          return null;
                        })}
                  </tr>
                  {forChild(data, i)}
                </>
              );
            })}

          {loading && (
            <tr>
              <td colSpan={showColumn.length ? showColumn.length : 5}>
                <Loader />
              </td>
            </tr>
          )}
          {isEmpty(state?.stateTestingTodoList) && !loading && (
            <tr>
              <td />
              <td colSpan={showColumn.length ? showColumn.length + 2 : 3}>
                <span className="d-flex align-items-center justify-content-start">No Testing to do found.</span>
              </td>
              <td />
            </tr>
          )}
        </tbody>
      </table>
      {showForPreview && <ForPreview onOpen={showForPreview} toggle={togglePreview} reportId={reportId} devOrderId={previewDevId} showData={prevData} />}
    </>
  );
}

export default List;
